import { render, staticRenderFns } from "./unclaim_button.vue?vue&type=template&id=482aef39&scoped=true&"
import script from "./unclaim_button.vue?vue&type=script&lang=ts&"
export * from "./unclaim_button.vue?vue&type=script&lang=ts&"
import style0 from "./unclaim_button.vue?vue&type=style&index=0&id=482aef39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482aef39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
